import React from 'react';

import { IconProps } from './types';

const CancelCircleFilled: React.FC<IconProps> = ({ size = 16, fillColor }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.3335C4.31333 1.3335 1.33333 4.3135 1.33333 8.00016C1.33333 11.6868 4.31333 14.6668 8 14.6668C11.6867 14.6668 14.6667 11.6868 14.6667 8.00016C14.6667 4.3135 11.6867 1.3335 8 1.3335ZM10.8667 10.8668C10.6067 11.1268 10.1867 11.1268 9.92666 10.8668L7.99999 8.94016L6.07333 10.8668C5.81333 11.1268 5.39333 11.1268 5.13333 10.8668C4.87333 10.6068 4.87333 10.1868 5.13333 9.92683L7.05999 8.00016L5.13333 6.0735C4.87333 5.8135 4.87333 5.3935 5.13333 5.1335C5.39333 4.8735 5.81333 4.8735 6.07333 5.1335L7.99999 7.06016L9.92666 5.1335C10.1867 4.8735 10.6067 4.8735 10.8667 5.1335C11.1267 5.3935 11.1267 5.8135 10.8667 6.0735L8.93999 8.00016L10.8667 9.92683C11.12 10.1802 11.12 10.6068 10.8667 10.8668Z"
        fill={fillColor || '#0276FE'}
      />
    </svg>
  );
};

export default CancelCircleFilled;
